
import { Vue, Component } from "vue-property-decorator";

import { getIsTicketAdmin } from "@share/common/helpers/ticketSystemHelpers";
import { TicketService } from "@share/common/services/ticket/TicketService";
import { TicketType } from "@share/ticketSystem/enums/TicketTypes";
import { TicketTableHelper } from "@share/ticketSystem/helpers/TicketTableHelper";

@Component({})

export default class ViewWithTicket<T extends { id: string}> extends Vue {
    ticketService: TicketService | null = null;
    ticketHelper: TicketTableHelper | null = null;
    ticketId = "";
    ticketType: TicketType | "" = "";
    state: "view" | "edit" | "" = "";

    openTicket(ticket: T, ticketType: TicketType) {
        this.state = "view";

        this.initTicketParams(ticket, ticketType);
    }

    editTicket(event: T, ticketType: TicketType) {
        this.state = "edit";

        this.initTicketParams(event, ticketType);
    }

    private initTicketParams(event: T, ticketType: TicketType) {
        this.ticketId = event.id;
        this.ticketType = ticketType;

        this.ticketService = new TicketService(this.$store, this.isTicketAdmin);
        this.ticketHelper = Vue.observable(new TicketTableHelper(this.ticketService, this.ticketType, this.$store));
    }

    resetTicketEditParams() {
        this.ticketId = "";
        this.ticketType = "";
        this.ticketService = null;
        this.ticketHelper = null;
    }

    get params() {
        return {
            ticketsType: this.ticketType,
            ticketService: this.ticketService,
            ticketHelper: this.ticketHelper
        }
    }

    private get isTicketAdmin() {
        if(this.ticketType) {
            return getIsTicketAdmin(this.$route?.name, this.$store.getters["groupIds"], this.ticketType)
        }
        else {
            return false;
        }
    }
}

